import { useContext } from 'react';
import { ThemeContext } from '../ThemeContext';

export const useThemeUtils = () => {
  const { theme, setCobrandTheme, updateTheme, updateColorMode } = useContext(ThemeContext);
  return { theme, setCobrandTheme, updateTheme, updateColorMode };
};
